export const DEFAULT_WORKTIME_NAME = 'Новый режим работы';
export const NEW_WORKTIME = { Name: DEFAULT_WORKTIME_NAME };
export const WORKTIME = 'Режим работы';
